export const urlResolverQuery = /* GraphQL */ `
    query urlResolver($url: String!) {
        urlResolver(url: $url) {
            entity_uid
            relative_url
            redirectCode
            type
        }
    }
`
